// Google Ads tag (account Muviarts Official). Live site only, so preview test payments never count.
export const GOOGLE_ADS_ID = "AW-18543842464";
const BLUEPRINT_PURCHASE = "AQ_7CKHfg64dEKCpsopF"; // conversion action "Purchase - Blueprint Ebook"

const LIVE = () => /(^|\.)muviarts\.in$/.test(window.location.hostname) || window.location.search.includes("gtag_test=1");
let started = false;

export function initGads() {
    if (started || !LIVE() || window.location.pathname.startsWith("/admin")) return;
    started = true;
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        const el = document.createElement("script");
        el.id = "gads-lib"; el.async = true;
        el.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
        document.head.appendChild(el);
    }
    window.gtag("config", GOOGLE_ADS_ID);
}

/** Blueprint purchase conversion. Resolves when Google has the hit (or after 1.5 s), so a redirect never drops it. */
export function gadsBlueprintPurchase(orderId, value) {
    return new Promise((resolve) => {
        try {
            initGads();
            if (!window.gtag || !started) return resolve();
            const done = () => resolve();
            window.gtag("event", "conversion", {
                send_to: `${GOOGLE_ADS_ID}/${BLUEPRINT_PURCHASE}`, value: Number(value) || 499, currency: "INR",
                transaction_id: orderId, event_callback: done,
            });
            setTimeout(done, 1500);
        } catch { resolve(); }
    });
}
